import { format, parseISO } from 'date-fns';

import { getDateRangePresetValue } from '@src/shared/lib/dateRangePresets';

import { generateDailyInvoicingData } from './dailyInvoicingMock';
import { generateOpenedCasesData } from './openedCasesMock';
import { generateTopClientsData, TOP_CLIENTS_WIDGET_LIMIT } from './topClientsMock';
import type { BoxPlotWidgetData, DashboardWidget } from '../types';

// Initial first-paint window for the dashboard tile, matching the DataRanger's
// default selection on the detail page ("this week") so the two stay in sync.
const OPENED_CASES_RANGE = getDateRangePresetValue('this_week') as {
  from: string;
  to: string;
};

const DAILY_INVOICING_RANGE = getDateRangePresetValue('this_month') as {
  from: string;
  to: string;
};

const TOP_CLIENTS_RANGE = getDateRangePresetValue('this_year') as {
  from: string;
  to: string;
};

const MARGINS_SERIES: BoxPlotWidgetData['series'] = [
  { id: 'q1_2026', label: 'Q1 2026' },
  { id: 'q1_2025', label: 'Q1 2025' },
  { id: 'budget_2026', label: 'Budget 2026', variant: 'marker' },
];

const MARGINS_DATA: BoxPlotWidgetData = {
  categories: ['National', 'International', 'Relocation'],
  series: MARGINS_SERIES,
  values: [
    {
      q1_2026: { max: 38, median: 24, min: 8, q1: 18, q3: 30 },
      q1_2025: { max: 32, median: 19, min: 6, q1: 14, q3: 25 },
      budget_2026: { max: 34, median: 28, min: 20, q1: 24, q3: 30 },
    },
    {
      q1_2026: { max: 62, median: 45, min: 30, q1: 40, q3: 52 },
      q1_2025: { max: 58, median: 42, min: 26, q1: 36, q3: 48 },
      budget_2026: { max: 60, median: 55, min: 48, q1: 52, q3: 58 },
    },
    {
      q1_2026: { max: 44, median: 27, min: 10, q1: 20, q3: 34 },
      q1_2025: { max: 46, median: 30, min: 12, q1: 22, q3: 38 },
      budget_2026: { max: 26, median: 20, min: 14, q1: 17, q3: 23 },
    },
  ],
};

export const DEFAULT_WIDGETS: DashboardWidget[] = [
  {
    dailyData: generateDailyInvoicingData(DAILY_INVOICING_RANGE).data,
    description: `${format(parseISO(DAILY_INVOICING_RANGE.from), 'dd.MM')} - ${format(parseISO(DAILY_INVOICING_RANGE.to), 'dd.MM.yyyy')}`,
    id: 'daily-invoicing',
    title: 'Daily invoicing',
    type: 'dailyInvoicing',
  },
  {
    description: `${format(parseISO(OPENED_CASES_RANGE.from), 'dd.MM')} - ${format(parseISO(OPENED_CASES_RANGE.to), 'dd.MM.yyyy')}`,
    id: 'opened-cases',
    openedCasesData: generateOpenedCasesData(OPENED_CASES_RANGE).data,
    title: 'Opened Cases',
    type: 'openedCases',
  },
  {
    description: `${format(parseISO(TOP_CLIENTS_RANGE.from), 'dd.MM')} - ${format(parseISO(TOP_CLIENTS_RANGE.to), 'dd.MM.yyyy')}`,
    id: 'top-clients',
    title: 'Top Clients',
    topClientsData: generateTopClientsData({
      ...TOP_CLIENTS_RANGE,
      limit: TOP_CLIENTS_WIDGET_LIMIT,
    }).data,
    type: 'topClients',
  },
  {
    boxPlotData: MARGINS_DATA,
    id: 'margins',
    title: 'Margins',
    type: 'boxPlot',
  },
  // ...Array.from({ length: 5 }, (_, index) => {
  //   const number = index + 2;

  //   return {
  //     description: `Dashboard Widget ${number} description`,
  //     id: `dashboard-widget-${number}`,
  //     title: `Dashboard Widget ${number}`,
  //   };
  // }),
];
